import * as React from 'react';
import MGCHistory from './HistoryRowData/MGCHistory';
import { getHeaderId, getHeaderInfotext } from '../utils';
import type { TFunctionalPerformanceMgravisDocumentType } from '../utils';
import FormEditingHandler from 'Containers/FormEditingHandler';
import DocumentWrapper from 'Components/DocumentWrapper';
import DocumentHeader from 'Components/DocumentHeader';
import Form from './Form';
import HistoryTabs from 'Components/HistoryTabs';
import { FormattedMessage } from 'react-intl';
import MGADLHistory from './HistoryRowData/MGADLHistory';
import { filterByDocumentType } from 'Utility/documentHandling';

const FunctionalPerformanceHistory = ({
  documents,
  startEdit,
  view,
  openTab,
  setOpenTab,
}: {
  documents: Array<IDocumentWithTypeV2<TFunctionalPerformanceMgravisDocumentType>>;
  startEdit: StartEdit;
  view?: IView;
  openTab: number;
  setOpenTab: (i: number) => void;
}): React.JSX.Element => {
  const MGCDocs = filterByDocumentType(documents, 'mgc');
  const MGADLDocs = filterByDocumentType(documents, 'mgadl');

  return (
    <React.Fragment>
      <HistoryTabs indexSelectionTools={{ index: openTab, changeFunction: index => setOpenTab(index) }}>
        {[
          {
            title: 'functionalPerformanceMgravis.mgcShort',
            content: <MGCHistory documents={MGCDocs} startEdit={startEdit} view={view} />,
          },
          {
            title: 'functionalPerformanceMgravis.mgadlShort',
            content: <MGADLHistory documents={MGADLDocs} startEdit={startEdit} view={view} />,
          },
        ]}
      </HistoryTabs>
    </React.Fragment>
  );
};

const FunctionalPerformanceMgravis = ({ documents }: IOwnProps): React.JSX.Element => {
  const [openTab, setOpenTab] = React.useState<number>(0);
  return (
    <FormEditingHandler name="functionalPerformanceMgravis" documents={documents}>
      {(editing, startEdit, formData, view): React.JSX.Element => {
        const infoText = getHeaderInfotext(documents, editing, view?.viewing);
        return (
          <DocumentWrapper>
            <DocumentHeader
              name="functionalPerformanceMgravis"
              headerId={getHeaderId(documents, editing, view?.viewing)}
              editing={editing}
              editButtons={<div />}
              infoText={
                infoText ? (
                  <FormattedMessage
                    id={infoText}
                    values={{
                      br: '\n',
                    }}
                  />
                ) : undefined
              }
            />
            {editing || view?.viewing ? (
              <Form
                formData={formData}
                document={documents.find(d => d._id === (editing || view?.viewing))}
                viewing={!!view?.viewing}
              />
            ) : null}
            {!editing && !view?.viewing ? (
              <FunctionalPerformanceHistory
                documents={documents}
                startEdit={startEdit}
                view={view}
                openTab={openTab}
                setOpenTab={setOpenTab}
              />
            ) : undefined}
          </DocumentWrapper>
        );
      }}
    </FormEditingHandler>
  );
};

interface IOwnProps {
  documents: Array<IDocumentWithTypeV2<TFunctionalPerformanceMgravisDocumentType>>;
}

export default FunctionalPerformanceMgravis;
